exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../../../../../../../node_modules/postcss-loader/index.js!../../../../../../styles.css"), "");

// module
exports.push([module.id, ".centered-div{\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.certificate-content{\n  max-height: 70vh;\n  overflow: hidden;\n  margin-bottom: 15px;\n}\n.legend{\n  font-size: 12px;\n  margin: 10px 5px 0 5px;\n}\n\n.certificate-container {\n  width: 100%;\n  height: 70vh;\n  border: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/content/certificate/preview/certificate-preview.component.css
// module id = 753
// module chunks = 0